var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10 16.6667H17.5M2.50003 16.6667H3.89548C4.30313 16.6667 4.50696 16.6667 4.69877 16.6206C4.86883 16.5798 5.03141 16.5125 5.18053 16.4211C5.34872 16.318 5.49285 16.1739 5.7811 15.8856L16.2501 5.41669C16.9404 4.72634 16.9404 3.60705 16.2501 2.91669C15.5597 2.22634 14.4404 2.22634 13.7501 2.91669L3.28108 13.3856C2.99283 13.6739 2.8487 13.818 2.74563 13.9862C2.65425 14.1353 2.58691 14.2979 2.54608 14.468C2.50003 14.6598 2.50003 14.8636 2.50003 15.2713V16.6667Z",
    stroke: "#099250",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.099101d947d84e57a3d0d8b147884490.svg";
export { ForwardRef as ReactComponent };